module.exports = __webpack_public_path__ + "static/img/20240419_3.2b60508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240419_3.png
// module id = Ijje
// module chunks = 0